import { render } from "./Materiali.vue?vue&type=template&id=ef4b90b8&scoped=true&ts=true"
import script from "./Materiali.vue?vue&type=script&lang=ts"
export * from "./Materiali.vue?vue&type=script&lang=ts"

import "./Materiali.vue?vue&type=style&index=0&id=ef4b90b8&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4b90b8"]])

export default __exports__